"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UINextButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _UIStepperButton = _interopRequireDefault(require("./UIStepperButton"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

function UINextButton(props) {
  return _react.default.createElement(_UIStepperButton.default, (0, _extends2.default)({
    "aria-label": _I18n.default.text('salesUI.UINextButton.label'),
    iconName: "next"
  }, props));
}

var EXCLUDED_STEPPER_BUTTON_PROP_NAMES = ['iconName', 'aria-label'];
UINextButton.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIStepperButton.default.propTypes, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.defaultProps = (0, _extends2.default)({}, (0, _omit.default)(_UIStepperButton.default.defaultProps, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.displayName = 'UINextButton';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/button/UINextButton.js
// module id = 801
// module chunks = 209 210 211 212